import { Edit, translate } from "react-admin";
import React from "react";

import SaleAgencyForm from "./SaleAgencyForm";

const SaleAgencyTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("saleagency.saleagency")}`}{" "}
      {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(SaleAgencyTitle);

export const SaleAgencyEdit = props => (
  <Edit title={<Title />} {...props}>
    <SaleAgencyForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/saleagency/SaleAgencyEdit.js